import React, { useMemo } from "react";
import { DefaultNavBarQuery } from "types/graphql-types";
import Links from "./Links";
import {
  cruisesLabel,
  cruisesLabelExpedition,
  cruisesLabelOcean
} from "src/utils/cruise";
import {
  CruisePerDestinationCounts2Result,
  useCruisePerDestinationCounts
} from "components/FindYourCruise/useCruisePerDestinationCount";

type DestinationLinksProps = {
  destinations: DefaultNavBarQuery["destinations"]["nodes"] | undefined;
  showItemsMedia?: boolean;
};
const DestinationLinks: React.FC<DestinationLinksProps> = ({
  showItemsMedia,
  destinations
}) => {
  const cruises = useCruisePerDestinationCounts(true);

  const links = useMemo(
    () =>
      (
        destinations?.map(destinationToLink(cruises, !!showItemsMedia)) || []
      ).sort((a, b) => a.label.localeCompare(b.label)),
    []
  );

  return <Links links={links} />;
};

const destinationToLink =
  (cruises: CruisePerDestinationCounts2Result, showItemsMedia: boolean) =>
  (destination: DefaultNavBarQuery["destinations"]["nodes"][number]) => {
    const cruisesCount = cruises[destination.destinationWebCode!];

    return {
      _key: destination.name!.localized!,
      href: destination.fullPath!,
      label: destination.name!.localized!,
      image: showItemsMedia ? destination.card?.image : undefined,
      trackingName: destination.metadata?.tracking?.name,
      content: cruisesLabelOceanAndExpedition(
        cruisesCount?.classic || 0,
        cruisesCount?.expedition || 0
      )
    };
  };

const cruisesLabelOceanAndExpedition = (
  classicCount: number,
  expeditionCount: number
) => {
  if (classicCount === 0 && expeditionCount === 0) {
    return cruisesLabel(0);
  }

  return (
    <div>
      {classicCount > 0 && <div>{cruisesLabelOcean(classicCount)}</div>}
      {expeditionCount > 0 && (
        <div>{cruisesLabelExpedition(expeditionCount)}</div>
      )}
    </div>
  );
};

export default DestinationLinks;
